
import { Component, Vue } from 'vue-property-decorator';
import { getStayRoomList, deleteStayRoom, copyStayRoom } from '@/api/stayRoom';
import Pagination from '@/components/Pagination/index.vue';

@Component({
  components: {
    Pagination,
  },
})
export default class extends Vue {
  mounted() {
    this.getStayRoomList();
  }

  private listQuery = {
    page: 1,
    size: 10,
    searchType: 'name',
    searchValue: '',
  }

  private searchTypes = [
    { label: '객실명', value: 'name' },
  ]

  private roomList = [];

  private totalElements = 0;

  private loading = true;

  private apiUrl = process.env.VUE_APP_BASE_API;

  private getStayRoomList() {
    this.loading = true;
    getStayRoomList(this.listQuery).then((res) => {
      this.roomList = res.data.content;
      this.totalElements = res.data.totalElements;
      this.loading = false;
    });
  }

  private handleSearch() {
    this.listQuery.page = 1;
    this.getStayRoomList();
  }

  private handleCopyRoom(room: any) {
    this.$confirm(`객실(${room.name})을 복사하시겠습니까?`, '객실 복사', {
      confirmButtonText: '복사',
      cancelButtonText: '취소',
      type: 'info',
    }).then(() => {
      copyStayRoom(room.idx).then(() => {
        this.$message.success('객실이 복사되었습니다.');
        this.getStayRoomList();
      });
    });
  }

  private handleDeleteRoom(room: any) {
    this.$confirm(`정말 객실(${room.name})을 삭제하시겠습니까?`, '객실 삭제', {
      confirmButtonText: '삭제',
      cancelButtonText: '취소',
      type: 'info',
    }).then(() => {
      deleteStayRoom(room.idx).then(() => {
        this.$message.success('객실이 삭제되었습니다.');
        this.getStayRoomList();
      });
    });
  }

  private bedType(room: any) {
    const str: any = [];
    if (room.singleBedNum > 0) str.push(`싱글베드${room.singleBedNum}`);
    if (room.doubleBedNum > 0) str.push(` 더블베드${room.doubleBedNum}`);
    if (room.twinBedNum > 0) str.push(` 트윈베드${room.twinBedNum}`);
    if (room.queenBedNum > 0) str.push(` 퀸베드${room.queenBedNum}`);
    if (room.kingBedNum > 0) str.push(` 킹베드${room.kingBedNum}`);
    if (room.beddingNum > 0) str.push(` 침구세트${room.beddingNum}`);
    return str.join(', ');
  }
}
